import React, { useRef } from "react";
import "./../styles/contact.css"; // Importando o CSS de Contact
import Maps from "../components/Maps"
import Contact from "./Contact";

const ContactPage = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    // Simulando envio de e-mail com mensagem de sucesso
    alert("Formulário enviado com sucesso!");
    e.target.reset();
  };

  return (
    <div>
        <Contact />
        <Maps />
    </div>
  );
};

export default ContactPage;